import { render, staticRenderFns } from "./NoAcademy.vue?vue&type=template&id=803afed6&scoped=true"
import script from "./NoAcademy.vue?vue&type=script&lang=js"
export * from "./NoAcademy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803afed6",
  null
  
)

export default component.exports